<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table">
            <template #default="{ row, property }">
                <el-link type="primary" :underline="false" @click="doUpdate(row)" v-if="property === 'code'">
                    {{ getName(row.code) }}
                </el-link>
                <template v-else-if="property === 'rule1'">
                    {{ row.thresholdBySecond + " / " + row.durationBySecond + "秒" }}
                </template>
                <template v-else-if="property === 'rule2'">
                    {{ row.thresholdByMinute + " / " + row.durationByMinute + "分" }}
                </template>
                <template v-else-if="property === 'rule3'">
                    {{ row.thresholdByHour + " / " + row.durationByHour + "时" }}
                </template>
                <template v-else-if="property === 'rule4'">
                    {{ row.thresholdByDay + " / " + row.durationByDay + "天" }}
                </template>
            </template>
        </RemoteTable>
    </div>
</template>

<script>
import RemoteTable from '@/components/RemoteTable'

export default {
    components: {
        RemoteTable
    },
    data() {
        return {
            form: {
                configs: this.getConfigs(),
                tools: [
                    {
                        icon: "el-icon-plus", click: () => {
                            this.$router.push("/rate/0")
                        }
                    }
                ]
            },
            table: {
                urlPrefix: "/raterule",
                columns: [
                    { label: "业务名称", name: "code" },
                    { label: "单日预警限额", name: "alertThreshold", width: 120 },
                    { label: "单日禁止限额", name: "forbiddenThreshold", width: 120 },
                    { label: "防轰炸规则1", name: "rule1", width: 120 },
                    { label: "防轰炸规则2", name: "rule2", width: 120 },
                    { label: "防轰炸规则3", name: "rule3", width: 120 },
                    { label: "防轰炸规则4", name: "rule4", width: 120 },
                    { label: "创建时间", name: "createTime", width: 150 },
                ],
                primaryColumns: [
                    { name: "code" }
                ],
                tools: []
            },
        }
    },
    methods: {
        getConfigs() {
            let configs = [];
            configs.push({ label: "业务", name: "code", type: "cascade", op: "beginwith", value: "" });
            return configs;
        },
        getName(code) {
            if (!code) {
                return "";
            }
            if ("00000" === code) {
                return "全局";
            }

            if (code.length > 6) {
                return this.$root.getBusinessName(code);
            } else {
                return this.$root.getCustomerName(code);
            }
        },
        doUpdate(row) {
            if (row.code == "00000") {
                this.$router.push("/rateglobal");
            } else {
                this.$router.push("/rate/" + row.id);
            }
        }
    }
}
</script>